import { cn } from "@/lib/utils";

interface LoadingLogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASSES = {
  sm: "h-7 w-7 border-2",
  md: "h-8 w-8 border-2",
  lg: "h-10 w-10 border-2",
} as const;

/**
 * Branded loading spinner (primary + accent). Use for page-level and in-card loading.
 */
export function LoadingLogo({
  size = "md",
  className,
}: LoadingLogoProps): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={cn("flex items-center justify-center", className)}
    >
      <div
        className={cn(
          "rounded-full border-2 border-primary border-t-transparent animate-spin motion-reduce:animate-none",
          SIZE_CLASSES[size]
        )}
      />
    </div>
  );
}
